export default __webpack_public_path__ + "static/media/download-regular-full.dc1d32bb.svg";